import { AdobeEvent } from './typing'

let loggedOnce = false
const getDataLayerArray = (
  _enabled: boolean,
  variableName: string = 'adobeDataLayer'
): AdobeEvent[] => {
  // Ensure the global data layer exists so other scripts (and dev console) can read pushed events
  // @ts-ignore
  if (!window[variableName]) {
    // initialize the global data layer
    // @ts-ignore
    window[variableName] = [] as AdobeEvent[]
    if (!loggedOnce) {
      loggedOnce = true
    }
  }
  // @ts-ignore
  return window[variableName] as AdobeEvent[]
}

export default getDataLayerArray
